import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { communityApi as defaultApi } from './community-api';
import { ProfilePhotoPromo } from './ProfilePhotoPromo';
import { PostComposer } from './PostComposer';
import { PostCard } from './PostCard';
import './community.css';

export function FeedPage({ api = defaultApi }) {
  const { user } = useAuth();
  const [scope, setScope] = useState('all');
  const [posts, setPosts] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async (nextScope = scope, nextCursor = null, append = false) => {
    setLoading(true);
    try { const result = await api.feed({ scope: nextScope, cursor: nextCursor }); setPosts(current => append ? [...current, ...(result.posts || [])] : (result.posts || [])); setCursor(result.nextCursor || null); }
    finally { setLoading(false); }
  }, [api, scope]);
  useEffect(() => { load(scope, null, false); }, [scope, load]);
  return <section className="gym-page community-page" aria-labelledby="community-title">
    <h1 id="community-title" className="gym-page__title">Comunidad</h1>
    <ProfilePhotoPromo />
    <PostComposer api={api} disabled={user?.communitySuspended === true} onPublished={() => load(scope, null, false)} />
    <div role="tablist" aria-label="Feed de comunidad" className="community-tabs community-tabs--scrollable">
      {[['all', 'Toda la comunidad'], ['following', 'Siguiendo'], ['official', 'Sólo HAMMER']].map(([value, label]) => <button key={value} type="button" className={`community-tabs__tab gym-admin-filter${scope === value ? ' gym-admin-filter--active' : ''}`} role="tab" aria-selected={scope === value} onClick={() => setScope(value)}>{label}</button>)}
    </div>
    {posts.map(post => <PostCard key={post.id} post={post} api={api} viewer={user} isAdmin={user?.role === 'admin'} onModerated={() => load(scope, null, false)} />)}
    {loading && <p className="gym-state gym-state--loading" role="status">Cargando publicaciones…</p>}
    {!loading && !posts.length && <p className="gym-state gym-state--empty">Todavía no hay publicaciones.</p>}
    {cursor && <button type="button" className="gym-button gym-button--secondary" disabled={loading} onClick={() => load(scope, cursor, true)}>Cargar más</button>}
  </section>;
}
